import { Service } from './baseService';

export const makeBookingPortalPaymentService = (data, companyID) => {
    let params = {};
    params.companyID = companyID;
    return Service.post(`/customer/makePayment`, data, { params });
};

export const getFiservTokenizerConfigService = (companyID) =>
    Service.get(`/customer/makePayment/fiservTokenizerConfig`, { params: { companyID } });

export const createPayrocHostedFieldSession = (companyID = null) => {
    let params = { companyID: companyID };
    return Service.post(`/customer/makePayment/payrocHostedFieldSession`, {}, { params });
};
